import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { CoordinatedAccountsCardView } from './CoordinatedAccountsCardView';
import {
  IntCoordinatedAccountsCardDocument,
  IntCoordinatedAccountsCardQuery,
} from './graphql/coordinatedAccountsCard.generated';

type ManagedAccount = IntCoordinatedAccountsCardQuery['envelopeAccount'] & { __typename: 'ManagedAccount' };
type ManagedSubAccounts = ManagedAccount['subAccounts'];

export const CoordinatedAccountsCard: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const householdId = useRequiredParam('householdId');
  const { data } = useGraphQLQuery(IntCoordinatedAccountsCardDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  if (!data) return <CardLoader />;

  const { envelopeAccount } = data;
  const subAccounts: ManagedSubAccounts =
    envelopeAccount.__typename === 'ManagedAccount' ? envelopeAccount.subAccounts : [];
  if (subAccounts.length <= 1) return null;

  return (
    <ErrorBoundary fallbackType="none">
      <CoordinatedAccountsCardView subAccounts={subAccounts} householdId={householdId} colorMode="light" />
    </ErrorBoundary>
  );
};
